/**
 * Масштабирует значения легенды для H3 слоя на основе h3_zoom
 *
 * Базовые значения для h3_zoom=10:
 * 3, 300, 1000, 4000, 8000, 25000
 *
 * Коэффициент масштабирования: 3 ^ (h3_zoom - 10)
 * h3_zoom=8:  ×(1/9) ÷9
 * h3_zoom=9:  ×(1/3) ÷3
 * h3_zoom=10: ×1 (базовый)
 * h3_zoom=11: ×3
 * h3_zoom=12: ×9
 */

const BASE_VALUES = [ 3, 300, 1000, 4000, 8000, 25000 ];
const BASE_ZOOM = 10;

export const scaleH3LegendValues = h3ZoomParam => {
    // Преобразуем параметр в числовое значение
    const h3Zoom = h3ZoomParam === 'auto' ? BASE_ZOOM : parseInt(h3ZoomParam, 10);
    // Вычисляем коэффициент: 3 ^ (h3_zoom - 10)
    const zoomDiff = h3Zoom - BASE_ZOOM;
    const coefficient = Math.pow(3, zoomDiff);
    // Масштабируем каждое значение (УМНОЖАЕМ, не делим!)
    return BASE_VALUES.map(value => Math.round(value * coefficient));
};

/**
 * Вспомогательная функция для форматирования значения в легенде
 * @param {number} value - Значение для форматирования
 * @returns {string} - Отформатированное значение
 */
export const formatH3LegendValue = value => {
    if (value >= 1000000) {
        return `${(value / 1000000).toFixed(1)}M`;
    }
    if (value >= 1000) {
        return `${(value / 1000).toFixed(1)}K`;
    }
    return String(value);
};
